import {
    useEffect,
    useState,
} from 'react';
import { useRecoilState } from 'recoil';
import CurrencyInput from 'react-currency-input-field';
import { authState } from 'store/state';
import Button from 'components/UI/Button';
import { useForm } from 'react-hook-form';
import { usePurchaseOrderForm } from 'services';
import toastAlert from 'components/UI/Alert';
import classNames from 'classnames';
import { blockInvalidChar } from 'helpers';
import { currentEnv } from 'configs';
import StyledForm from './styles';

const EMAIL_PATTERN = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

const Form = ({
    t,
    rate,
    setFormSubmitted,
}) => {
    const [tokens, setTokens] = useState(0);
    const [auth] = useRecoilState(authState);
    const { currentAddress } = auth;

    const {
        register,
        setValue,
        handleSubmit,
        watch,
        formState: { errors },
    } = useForm();

    const {
        isLoading,
        onSubmit,
    } = usePurchaseOrderForm();

    const onFormSubmit = async (data) => {
        const currentSale = currentEnv.name.split('_')[2];
        const phase = currentSale ? `Phase ${currentSale}` : 'Advisors';
        const formData = {
            ...data, address: currentAddress, tokens, phase,
        };
        const subscribe = await onSubmit(formData);
        if (subscribe.status !== 200) {
            return toastAlert({
                type: 'error',
                message: t('somethingWentWrong'),
            });
        }
        setFormSubmitted(true);
    };

    useEffect(() => {
        const subscription = watch((value, { name }) => {
            if (name === 'amount') {
                setTokens((value.amount || 0) * rate);
            }
        });
        return () => subscription.unsubscribe();
    }, [watch, rate]);

    return (
        <StyledForm onSubmit={handleSubmit(onFormSubmit)}>
            <div className="inputGroup">
                <label htmlFor="">Your Ethereum Address</label>
                <input
                    type="text"
                    disabled
                    value={currentAddress}
                />
                <p>This address will also be used to claim FTN tokens after the lockup and vesting periods.</p>
            </div>
            <div className={classNames('inputGroup', { invalid: errors.name })}>
                <label htmlFor="">Name Surname</label>
                <input
                    type="text"
                    placeholder="Enter your name and surname"
                    {...register('name', { required: true })}
                />
            </div>
            <div className={classNames('inputGroup', { invalid: errors.email })}>
                <label htmlFor="">Fastex Email Address</label>
                <input
                    type="text"
                    placeholder="Enter email"
                    {...register('email', { required: true, pattern: EMAIL_PATTERN })}
                />
                <p>
                    Please provide the same email address you used to register on
                    {' '}
                    <a
                        href="https://fastex.com/"
                        target="_blank"
                        rel="noreferrer"
                    >
                        Fastex.com
                    </a>
                    . This email will also be used for all further communication.
                </p>
            </div>
            {currentEnv.name === 'ADVISORS' && (
                <div className={classNames('inputGroup', { invalid: errors.position })}>
                    <label htmlFor="">Your position</label>
                    <input
                        type="text"
                        placeholder="Enter position"
                        {...register('position', { required: true })}
                    />
                </div>
            )}
            {currentEnv.name !== 'ADVISORS' && (
                <>
                    <div className={classNames('inputGroup', { invalid: errors.paymentMethod })}>
                        <label htmlFor="">Payment Method</label>
                        <select {...register('paymentMethod', { required: true })}>
                            <option>Crypto - USDT (TRC-20)</option>
                            <option>Crypto - USDT (ERC-20)</option>
                            <option>Crypto - Other</option>
                            <option>Bank transfer - EURO</option>
                            <option>Bank transfer - USD</option>
                        </select>
                    </div>
                    <div className={classNames('inputGroup', { invalid: errors.amount })}>
                        <label htmlFor="">Investment Amount | EURO (max. €250,000)</label>
                        <CurrencyInput
                            name="amount-field"
                            placeholder="Enter amount"
                            allowNegativeValue={false}
                            onKeyDown={blockInvalidChar}
                            onValueChange={(value = 0) => setValue('amount', value)}
                        />
                    </div>
                    <div className="inputGroup">
                        <label htmlFor="">FTN Equivalent</label>
                        <input
                            type="text"
                            disabled
                            value={`${new Intl.NumberFormat().format(tokens)} FTN`}
                        />
                    </div>
                </>
            )}

            <Button
                loading={isLoading}
            >
                SUBMIT
            </Button>
        </StyledForm>
    );
};

export default Form;
